/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const NextActionDriverDefault = `auto`;
export const NextActionDriver = zod
  .enum(['auto', 'appointment', 'task', 'approval'])
  .default(NextActionDriverDefault)
  .describe(
    'Source of the next action. `auto` returns the highest-ranked item across all sources: an appointment in the next 24 h, then a pending approval, then a later appointment, then a task.',
  );

export type NextActionDriver = zod.input<typeof NextActionDriver>;
export type NextActionDriverOutput = zod.output<typeof NextActionDriver>;
